import { render, staticRenderFns } from "./build-dialog.vue?vue&type=template&id=0254ce90"
import script from "./build-dialog.vue?vue&type=script&lang=js"
export * from "./build-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0254ce90')) {
      api.createRecord('0254ce90', component.options)
    } else {
      api.reload('0254ce90', component.options)
    }
    module.hot.accept("./build-dialog.vue?vue&type=template&id=0254ce90", function () {
      api.rerender('0254ce90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/biz/components/ServiceMode/Building/components/build-dialog.vue"
export default component.exports